<template>
  <v-layout
    :class="['workshop-container', !ticketAvailable && !isPartOfCategory && 'not-available']"
    :style="{
      backgroundColor:
        numberOfTicket !== 0 && numberOfTicket < max_number
          ? backgroundColor
          : activeBackgroundColor,
      border: !isPartOfCategory
        ? `1px solid #33333380`
        : numberOfTicket !== 0 && numberOfTicket < max_number
          ? `1px solid ${cardColor}`
          : `1px solid ${cardColor}80`,
      color: `${cardColor}${!ticketAvailable ? '99' : ''}`,
    }"
    justify-space-between
    :column="$vuetify.breakpoint.xsOnly"
  >
    <div class="ticket-data">
      <span class="ticket-name">{{ workflowLabel(ticket.name) }} </span>
      <div
        v-if="ticket.bundleOffer && ticket.bundleOffer.availableQuantity > 0"
        class="bundle-offer-label"
        :style="{
          background: `linear-gradient(0deg, rgba(255, 255, 255, ${
            !ticketAvailable ? '0.96' : '0.95'
          }) 0%, rgba(255, 255, 255, 0.95) 100%), ${cardColor || '#666'}
`,
          color: cardColor,
        }"
      >
        {{ workflowLabel(ticket.bundleOffer.quantityInterval) }}+{{ workflowLabel(ticket.bundleOffer.freeQuantity) }} {{ adminText('workflowsAll.gratis_6d65eea', 'GRATIS') }}
      </div>
      <span
        v-if="ticket.description"
        class="ticket-description"
        :style="
          descriptionExpanded
            ? 'overflow: auto; white-space: pre-line;'
            : `overflow: hidden;  ${
              clientWidth < 800 ? 'white-space: pre-line' : 'white-space: nowrap'
            } `
        "
      >
        {{ workflowLabel(ticket.description) }}
        <a
          v-if="ticket.id === '15655'"
          href="https://accreditationmanager.s3.eu-central-1.amazonaws.com/a-perfect-circle-vip-terms.pdf"
          target="_blank"
        >{{ adminText('workflowsAll.vip_terms_and_conditions_c738faf', 'VIP terms and conditions') }}</a>
      </span>
      <div
        v-if="ticket.description && descriptionExpanded"
        class="expand-description-container"
        :style="{
          display: ['25854', '25855', '25856'].includes(ticket.id) ? 'none' : 'block',
        }"
        @click="descriptionExpanded = !descriptionExpanded"
      >
        <span>{{ adminText('workflowsAll.read_less_80d817c', 'READ LESS') }}</span>
        <v-icon
          :style="{
            color: !ticketAvailable
              ? !isPartOfCategory
                ? `#979797`
                : `${cardColor}99`
              : `${cardColor}`,
          }"
        >
          expand_less
        </v-icon>
      </div>
      <div
        v-else-if="ticket.description"
        class="expand-description-container"
        @click="descriptionExpanded = !descriptionExpanded"
      >
        <span>{{ adminText('workflowsAll.read_more_78577db', 'READ MORE') }}</span>
        <v-icon
          :style="{
            color: !ticketAvailable
              ? !isPartOfCategory
                ? `#979797`
                : `${cardColor}99`
              : `${cardColor}`,
          }"
        >
          expand_more
        </v-icon>
      </div>
      <div v-if="ticket.itemMeta.min && numberOfTicket > 0 && numberOfTicket < ticket.itemMeta.min">
        ⚠️ {{ workflowLabel(workflowCustomerLabel('chooseMinimum', {}, $t('chooseMinimum'))) }} {{ workflowLabel(ticket.itemMeta.min) }}
        {{ workflowLabel(ticket.itemMeta.min % 10 > 4 ? workflowCustomerLabel('tickets1', {}, $t('tickets1')) : workflowCustomerLabel('tickets2', {}, $t('tickets2'))) }}
      </div>
    </div>
    <div
      class="price-and-quantity-container"
      :style="{
        background: `linear-gradient(0deg, rgba(255, 255, 255, ${
          !ticketAvailable ? '0.96' : '0.95'
        }) 0%, rgba(255, 255, 255, 0.95) 100%), ${cardColor || '#666'}
`,
      }"
    >
      <div class="price-container">
        <div
          :style="{
            textDecoration:
              promoCode && promoCode.orderItems.map(oi => oi.id).includes(ticket.id)
                ? 'line-through'
                : 'none',
            opacity:
              promoCode && promoCode.orderItems.map(oi => oi.id).includes(ticket.id) ? 0.6 : 1,
          }"
        >
          <span class="price-item-eur">
            {{ workflowLabel(Number.parseFloat(ticket.price).toFixed(2)) }}
            {{ workflowLabel(ticket.currency === 'EUR' ? '&euro;' : ticket.currency) }}
          </span>
        </div>
        <div v-if="promoCode && promoCode.orderItems.map(oi => oi.id).includes(ticket.id)">
          <span class="price-item-eur">
            {{ workflowLabel(getTicketPrice()) }}
            {{ workflowLabel(ticket.currency === 'EUR' ? '&euro;' : ticket.currency) }}
          </span>
        </div>
      </div>
      <span
        v-if="disableSportMembershipTicket"
        class="soldOut"
        :style="{
          background: !isPartOfCategory ? `#33333399` : `${cardColor}99`,
        }"
      >{{ workflowLabel(workflowCustomerLabel('disableSportMembershipTicket', {}, $t('disableSportMembershipTicket'))) }}</span>
      <span
        v-else-if="!ticketAvailable"
        class="soldOut"
        :style="{
          background: !isPartOfCategory ? `#33333399` : `${cardColor}99`,
        }"
      >{{ adminText('workflowsAll.sold_out_02ff659', 'Sold out') }}</span>
      <v-flex v-else align-self-flex-end class="add_ticket">
        <v-icon
          :id="'reduceAmount-' + ticket.id"
          slot="activator"
          :color="color"
          icon
          class="quantity-icon"
          :disabled="!numberOfTicket"
          :number-of-ticket="numberOfTicket"
          style="font-size: 2rem"
          @click="subOne"
        >
          remove_circle
        </v-icon>
        <div class="ticket-number" translate="no">{{ workflowLabel(numberOfTicket) }}</div>
        <v-icon
          :id="'increaseAmount-' + ticket.id"
          slot="activator"
          :color="color"
          icon
          class="quantity-icon"
          :disabled="numberOfTicket == max_number || !canAddMore"
          :number-of-ticket="numberOfTicket"
          style="font-size: 2rem"
          @click="addOne"
        >
          add_circle
        </v-icon>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { round } from 'mathjs'
import { exchangeRate } from '../../../src/utils'
import moment from 'moment'

export default {
  mixins: [WorkflowDisplay],
  name: 'ticket-card',
  props: {
    promoCode: {
      default: null,
      type: Object,
    },
    ticket: {
      type: Object,
    },
    canAddMore: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    colorZkm: {
      type: String,
      default: '#333333',
    },
    event: {
      type: Object,
      default: () => {},
    },
    backgroundColor: {
      type: String,
      default: 'primary',
    },
    activeBackgroundColor: {
      type: String,
      default: '#f5f5f5',
    },
    items: {
      type: Array,
      default: () => [],
    },
    isPartOfCategory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: this.ticket,
      exchangeRate: exchangeRate,
      max_number: this.ticket.quantity,
      ticketAvailable: this.ticket.quantity > 0 && moment(this.ticket.to).isAfter(new Date()),
      numberOfTicket: this.items.filter(item => item.id === this.ticket.id).length,
      zkmColor: '#333333',
      descriptionExpanded: false,
      clientWidth: document.documentElement.clientWidth,
    }
  },
  computed: {
    disableSportMembershipTicket() {
      return this.ticket.itemMeta.sportMembershipTicket && this.item.quantity === 0
    },
    cardColor() {
      if (this.isPartOfCategory) {
        return this.color
      }

      return this.numberOfTicket !== 0 && this.numberOfTicket < this.max_number
        ? this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
          ? '#333333'
          : this.color
        : '#333333'
    },
  },
  watch: {
    numberOfTicket: function () {
      return this.items.filter(item => item.id === this.ticket.id).length
    },
  },
  mounted() {
    if (this.ticket.id === '15655') {
      this.ticket.description = `VIP ticket includes:
- One (1) General Admission ticket
- Autographed VIP Exclusive Collectible Lithograph: Hand-Signed by the Band
- Exclusive APC Medallion Necklace
- Handmade Leather Wrist Cuff
- Early Entry into the Venue
- Official VIP Laminate & Lanyard
- Crowd Free, Pre-Show Merchandise Shopping`
    }
    if (['18606', '18614', '18604', '18602'].includes(this.ticket.id)) {
      this.ticket.description = `Ticket includes:
- One GA ticket to see Empire of the Sun live with early venue entry
- Exclusive photo opportunity and meet and greet with Luke Steele before the show
- One limited edition tour poster, signed by Empire of the Sun
- One exclusive Empire of the Sun VIP merchandise gift
- One VIP laminate
- Early merchandise shopping opportunity
- Dedicated VIP venue entrance*
- On-site VIP host`
    }
    if (['25854', '25855', '25856'].includes(this.ticket.id)) {
      this.descriptionExpanded = true
    }
  },
  beforeUpdate() {
    this.max_number = this.ticket.quantity
    this.ticketAvailable = this.ticket.quantity > 0 && moment(this.ticket.to).isAfter(new Date())
  },
  methods: {
    getTicketPrice() {
      return this.promoCode.discountType === 'AMOUNT'
        ? round(this.ticket.price - this.promoCode.discountAmount, 2)
        : round((this.ticket.price * (100 - this.promoCode.discountPercentage)) / 100, 2)
    },
    addOne() {
      if (this.numberOfTicket < this.max_number || !this.max_number) {
        this.numberOfTicket++
        this.$emit('added', this.ticket)
      }
    },
    subOne() {
      if (this.numberOfTicket >= 1) {
        this.numberOfTicket--
        this.$emit('removed', this.ticket)
      }
    },
  },
}
</script>

<style scoped>
.workshop-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 1.33;
  margin-bottom: 8px;
  margin-right: 24px;
  @media screen and (max-width: 385px) {
    font-size: 15px;
  }
}

.zkm-layout {
  display: flex;
  @media only screen and (max-width: 620px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.workshop-container {
  border-radius: 4px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  max-width: 50.1875rem;
}

.workshop-container-zkm {
  margin: 2.4px 0;
  border: solid var(--grey-00, #333);
  border-width: 2px 0;
  border-radius: 0px;
  background-color: transparent !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #979797;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.ticket-number {
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  text-transform: uppercase;
  min-width: 3.375rem;
}

.disabled .workshop-title span,
.disabled span > span {
  color: #333333;
}

.add_ticket_icons {
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: flex-end;
  height: 100%;
}

.add_ticket {
  display: flex;
  align-self: center;
  justify-content: flex-end;
}

.soldOut {
  padding: 0.25rem 0.75rem;
  border-radius: 17.5px;
  height: fit-content;
  opacity: 0.5;
  color: #f5f5f5;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Source Sans Pro;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}

.quantity-icon {
  user-select: none;
}

.ticket-data {
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 60%;
  max-width: 100%;
  flex: 2;
}

.ticket-name {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}

.ticket-description {
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  flex: 1;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.expand-description-container {
  :hover {
    cursor: pointer;
  }
}

.price-and-quantity-container {
  padding: 1rem 1.5rem;
  display: flex;
  gap: 0.5rem;
  border-radius: 0 4px 4px 0;
  align-items: center;
  border-radius: 0 3px 3px 0;
  justify-content: space-between;
  flex: 1;
}

.price-container {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  max-width: 14rem;
  min-width: 5rem;
}

.price-item-eur {
  display: block;
  white-space: nowrap;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Source Sans Pro;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  text-transform: uppercase;
}

.bundle-offer-label {
  padding: 4px 12px;
  border-radius: 17.5px;

  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 14.4px */
  letter-spacing: 0.18px;
  text-transform: uppercase;
}
</style>
